import React, { memo, useState, useEffect } from 'react';
import styles from './filterGps.module.scss';
import FilterContent from '../../../shared/components/FilterContent';
import Button from '../../../shared/components/Button';
import Input from '../../../shared/components/Input';
import CustomSelect from '../../../shared/components/CustomSelect';
import AutoCompleteUsers from '../AutoCompleteUsers';
import DatePicker from '../../../shared/components/DatePicker';
import CreateGps from '../CreateGps';
import { useTranslation } from 'react-i18next';

import { defaultStatusOptionsFilter, defaultSubstatusOptionsFilter, defaultUsersOptionsFilter, defaultEnabledOptionsFilter } from '../../../app/conf';
import { defaultFilters, updateStockViewFilters } from '../GpsLoader/GpsLoader';

const FiltersGps = ({
    showCreateButton = true,
    isStockGps = false,
    getGpsStatusesRequest,
    getGpsSubstatusRequest,
    setGpsFilters,
    filters,
    gps: { fetching, statuses, substatus: substatuses, statusesFetching, substatusFetching, fetchingExport },
    getExportGpsRequest,
    filtersToUseInQuery,
    closePingEventExportGps,
    getGpsDevicesRequest
}) => {
    const { t } = useTranslation(['home', 'devices']);
    const pad2 = n => String(n).padStart(2, '0');
    const formatDate = date => {
        if (!date || !(date instanceof Date)) return null;
        const y = date.getFullYear();
        const m = pad2(date.getMonth() + 1);
        const d = pad2(date.getDate());
        return `${y}-${m}-${d}`;
    };
    const [defaultStatusOpt, setDefaultStatusesOptions] = useState([
        {
            ...defaultStatusOptionsFilter,
            label: t(defaultStatusOptionsFilter.label)
        }
    ]);

    const [defaultSubstatusOpt, setDefaultSubstatusOptions] = useState([
        {
            ...defaultSubstatusOptionsFilter,
            label: t(defaultSubstatusOptionsFilter.label)
        }
    ]);

    const [defaultUsersOpt] = useState({
        ...defaultUsersOptionsFilter,
        label: t(defaultUsersOptionsFilter.label)
    });

    const [defaultEnabledOpt] = useState([
        ...defaultEnabledOptionsFilter.map(subStatus => ({
            ...subStatus,
            label: t(subStatus.label)
        }))
    ]);

    const [enabled, setEnabled] = useState({ ...defaultEnabledOpt[0] });
    const [status, setStatus] = useState({ ...defaultStatusOpt[0] });
    const [assigned, setAssigned] = useState({ ...defaultUsersOpt });
    const [name, setName] = useState('');
    const [imei, setImei] = useState('');
    const [simcard, setSimcard] = useState('');
    const [substatus, setSubstatus] = useState({ ...defaultEnabledOpt[0] });
    const [date, setDate] = useState(undefined);
    const substatusReadOnly = !status || status._id === defaultStatusOptionsFilter._id;


    const handleAssigned = user => setAssigned(user);
    const handleStatus = status => {
        setStatus(status);
        setSubstatus(null);
        const formatted = toCodeStatusFormat(status.label || status.value);

        if (status && status.label && !['baja', 'ok'].includes(status.label.trim().toLowerCase())) {
            getGpsSubstatusRequest({ codeStatus: formatted });
        }
    };
    const handleSubstatus = substatus => setSubstatus(substatus);
    const handleName = e => {
        const q = e.target.value;
        setName(q);
        setImei(q);
        setSimcard(q);
      };
    const handleEnabled = enabled => setEnabled(enabled);
    const handleDate = date => setDate(date);

    const toCodeStatusFormat = (label) => {
        if (!label) return '';

        const exceptions = {
          'bodega-lab': 'Bodega-laboratorio',
        };

        const cleaned = label.trim().replace(/\s*-\s*/g, '-');
        const formatted = cleaned.toLowerCase().replace(/\s+/g, '-');

        const finalFormatted = exceptions[formatted] || formatted;

        return finalFormatted.charAt(0).toUpperCase() + finalFormatted.slice(1);
      }

    const hasActiveFilters = () => {
        if (isStockGps) {
            return name || 
                   status._id !== defaultStatusOptionsFilter._id || 
                   substatus._id !== defaultSubstatusOptionsFilter._id || 
                   enabled._id !== defaultEnabledOptionsFilter[0]._id || 
                   enabled.value !== defaultEnabledOptionsFilter[0].value || 
                   date;
        }
       
    };

    const filtersGps = () => {
  
    const stored = localStorage.getItem('gpsDevicesFilter');
    if (stored) {
        try {
            const parsed = JSON.parse(stored);
            if (parsed.imei) {
                const filters = {
                    search: parsed.imei,
                    imei: parsed.imei,
                    simcard: '',
                    status,
                    substatus,
                    date: formatDate(date),
                    enabled,
                    assigned
                };
                setGpsFilters(filters);

                updateStockViewFilters(filters);
                
                if (typeof getGpsDevicesRequest === 'function') {
                    getGpsDevicesRequest({ ...defaultFilters, ...filters });
                }
                
                localStorage.removeItem('gpsDevicesFilter');
                return;
            } else if (parsed.simcard) {
                const filters = {
                    search: parsed.simcard,
                    simcard: parsed.simcard,
                    imei: '',
                    status,
                    substatus,
                    date: formatDate(date),
                    enabled,
                    assigned
                };
                setGpsFilters(filters);

                updateStockViewFilters(filters);
                
                if (typeof getGpsDevicesRequest === 'function') {
                    getGpsDevicesRequest({ ...defaultFilters, ...filters });
                }
                
                localStorage.removeItem('gpsDevicesFilter');
                return;
            }
        } catch (e) {}
    }
    const q = name ? name.trim() : '';
    const dateFrom = formatDate(date);
    const filters = {
        search: q || undefined,
        status,
        substatus,
        date: dateFrom,
        enabled,
        assigned
    };
    setGpsFilters(filters);
    
    const requestFilters = { ...defaultFilters, ...filters };
    updateStockViewFilters(filters);
    
    if (typeof getGpsDevicesRequest === 'function') {
        getGpsDevicesRequest(requestFilters);
    }
};

    const exportGps = () => {
        const timeZone = new Date().getTimezoneOffset();
        const exportFilters = {
            ...defaultFilters,
            ...filtersToUseInQuery,
            tz: timeZone
        };
        getExportGpsRequest(exportFilters);
    };

    const handleClearFilters = () => {
        setName('');
        setImei('');
        setSimcard('');
        setDate(undefined);

        setStatus({ ...defaultStatusOpt[0] });
        const initialSubstatus = {
            ...defaultSubstatusOptionsFilter,
            label: t(defaultSubstatusOptionsFilter.label)
        };
        setSubstatus(initialSubstatus);
        setDefaultSubstatusOptions([initialSubstatus]);

        setEnabled({ ...defaultEnabledOpt[0] });
        setAssigned({ ...defaultUsersOpt });

        setGpsFilters({
            search: '',
            status: { ...defaultStatusOpt[0] },
            substatus: initialSubstatus,
            enabled: { ...defaultEnabledOpt[0] },
            date: null,
            assigned: { ...defaultUsersOpt }
        });
        const clearedFilters = {
            search: '',
            status: { ...defaultStatusOpt[0] },
            substatus: initialSubstatus,
            enabled: { ...defaultEnabledOpt[0] },
            date: null,
            assigned: { ...defaultUsersOpt }
        };
    
        setGpsFilters(clearedFilters);
        
        updateStockViewFilters(clearedFilters);

        getGpsDevicesRequest({ ...defaultFilters, ...clearedFilters });
    };

    useEffect(() => {
        if (statuses.length) {
            const filteredStatuses = statuses.filter(st => {
                return st.name?.trim().toLowerCase() !== 'ok';
            });
    
            setDefaultStatusesOptions([
                {
                    ...defaultStatusOptionsFilter,
                    label: t(defaultStatusOptionsFilter.label)
                },
                ...filteredStatuses.map(st => ({
                    _id: st._id,
                    value: st._id,
                    label: st.name
                }))
            ]);
        }
    }, [statuses, t]);
    

    useEffect(() => {
        if (substatuses && substatuses.length) {
            const substatusOpts = substatuses.map(st => ({
                _id: st._id,
                value: st._id,
                label: st.name
            }));
            setDefaultSubstatusOptions(substatusOpts);
        } else {
            setDefaultSubstatusOptions([]);
        }
    }, [substatuses]);

    useEffect(() => {
        getGpsStatusesRequest();
    }, [getGpsStatusesRequest]);


    useEffect(() => {
        const stored = localStorage.getItem('gpsDevicesFilter');
        let triggeredFromExternal = false;
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                if (parsed.imei) {
                    setName(parsed.imei);
                    setImei(parsed.imei);
                    setSimcard('');
                    triggeredFromExternal = true;
                } else if (parsed.simcard) {
                    setName(parsed.simcard);
                    setSimcard(parsed.simcard);
                    setImei('');
                    triggeredFromExternal = true;
                }
            } catch (e) {}
            localStorage.removeItem('gpsDevicesFilter');
        } else {
            setName(filters.name);
        }

        if (triggeredFromExternal) {
            setTimeout(() => {
                filtersGps();
            }, 100);
        }

        if (filters.status && Object.keys(filters.status).length) {
            setStatus(filters.status);
        }
        if (filters.substatus && Object.keys(filters.substatus).length) {
            setSubstatus(filters.substatus);
        }
        if (filters.enabled && Object.keys(filters.enabled).length) {
            setEnabled(filters.enabled);
        }
        if (isStockGps && filters.date) {
            setDate(filters.date);
        }
    }, [filters]);

    useEffect(() => {
        return () => closePingEventExportGps();
    }, [closePingEventExportGps])

    

    return (
        <div className={styles.header}>
            <FilterContent className={styles.filterContent}>
                    <>
                        <DatePicker
                            key={date instanceof Date ? date.toISOString() : 'empty'}
                            selected={date}
                            onChange={handleDate}
                            placeholder="Fecha"
                            maxDate={new Date()}
                            isClearable
                            showYearDropdown
                            dateFormat="yyyy-MM-dd"
                        />

                        <div className={styles.searchInput}>
                        <Input placeholder="Nombre, IMEI, Simcard, Modelo" value={name} onChange={handleName} />
                         <svg 
                            className={styles.searchIcon} 
                            width="16" 
                            height="16" 
                            viewBox="0 0 20 20" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M14 14L11 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>

                      
                    </>
                
                <CustomSelect
                    value={status}
                    onChange={handleStatus}
                    placeholder={t('home:statuses')}
                    options={defaultStatusOpt}
                    loading={statusesFetching}
                    inputFilter
                />
                <CustomSelect

                    value={substatus}
                    onChange={handleSubstatus}
                    placeholder={'Sub-estados'}
                    options={defaultSubstatusOpt}
                    inputFilter
                    readOnly={!status || status._id === defaultStatusOptionsFilter._id}
                    className={substatusReadOnly ? styles.disabled : ''}
                />
                {!isStockGps && (
                    <AutoCompleteUsers
                        assigned={assigned}
                        handleAssigned={handleAssigned}
                        placeholder={t('devices:assigned')}
                        defaultOptions={defaultUsersOpt}
                        inputFilter
                    />
                )}
                <Button
                onClick={handleClearFilters}
                className={styles.buttonLimpiar}
                variant="secondary"
                type="button"
            >
                Limpiar
                 </Button>
                 <Button 
                    onClick={filtersGps} 
                    className={styles.button} 
                    loading={fetching}
                >
                    Aplicar
                </Button>
                
            </FilterContent>
            <div className={styles.createGpsContainer}><CreateGps buttonClassName={styles.createGpsButton} /></div>
        </div>
    );
};

export default memo(FiltersGps);
